import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_APPOINTMENT_SEARCH,
    getAppointmentSearchFail,
    getAppointmentSearchSuccess
} from '../action/getAppointmentSearchAction'

// api 
import getAppointmentSearchApi from '../api/getAppointmentSearchApi'

export function* getAppointmentSearchSaga(action) {
    try {
        const response = yield call(() => getAppointmentSearchApi(action.params))
        if (response.data.status === 1) {
            yield put(getAppointmentSearchSuccess(response, action))
        } else {
            yield put(getAppointmentSearchFail(response, action))
        }
    }
    catch (e) {
        yield put(getAppointmentSearchFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_APPOINTMENT_SEARCH, getAppointmentSearchSaga)
}